import { Content, Flex, usePlatformInfo, usePlatformProps } from '@acsbe/ui';
import { Dispatch, SetStateAction } from 'react';
import { useBilling } from '../../../context';
import { StripeLoader } from '../../../context/stripe';
import { AddPaymentMethodForm } from './add-payment-method';
import { ChoosePaymentMethodSection } from './Choose-payment-method';
import { BorderedFlex } from './common';
import { ErrorBanner } from './ErrorBanner';

interface CardDetailsProps {
  paymentError: string | null;
  setPaymentError: Dispatch<SetStateAction<string | null>>;
  errorIconName: import('@acsbe/ui').StrokeIconName;
  errorIconScale: 'danger' | 'warning' | 'success' | 'base';
}

export const CardDetails = ({
  paymentError,
  setPaymentError,
  errorIconName,
  errorIconScale,
}: CardDetailsProps) => {
  const {
    billingMethods,
    selectedBillingId,
    setSelectedBillingId,
    billingAddressLoaded,
  } = useBilling();
  const { uptoPhablet, uptoDesktopXs } = usePlatformInfo();
  const p = usePlatformProps();

  return (
    <Flex
      scale="ghost"
      align="flex-start"
      stretch
      radius="xl"
      border="xxs"
      width="100%"
      maxWidth="700px"
      overflow="hidden"
      {...(uptoDesktopXs && { self: 'stretch' })}
      {...p.uptoDesktopXs({ maxWidth: '100%' })}
    >
      <BorderedFlex
        setBorderBottom
        paddingBlock={4}
        paddingInline={6}
        justify="center"
        align="flex-start"
        gap={1}
        self="stretch"
      >
        <Content
          scale="base"
          size={uptoPhablet ? 'md' : 'lgb'}
          emphasis="low"
          lineHeight={1.25}
        >
          Payment Details
        </Content>
        <Content scale="alternative" size="md" emphasis="none" lineHeight={1.5}>
          Your card will be securely saved for future payments after
          confirmation
        </Content>
      </BorderedFlex>
      {billingMethods && billingAddressLoaded ? (
        billingMethods.length > 0 ? (
          <Flex stretch width="100%">
            {paymentError && (
              <Flex paddingBlock={4} paddingInline={3}>
                <ErrorBanner
                  message={paymentError}
                  onDismiss={() => setPaymentError(null)}
                  iconName={errorIconName}
                  iconScale={errorIconScale}
                />
              </Flex>
            )}
            <ChoosePaymentMethodSection
              selectedBillingId={selectedBillingId}
              onBillingChange={setSelectedBillingId}
              setPaymentError={setPaymentError}
            />
          </Flex>
        ) : (
          <AddPaymentMethodForm />
        )
      ) : (
        <StripeLoader />
      )}
    </Flex>
  );
};
